document.addEventListener("turbolinks:load", () => {
  /* setting background images */
  $('.bg_image_holder').each(function () {
    var $this = $(this);
    var imgLink = $this.children().attr('src');
    $this.css({
      "background-image": "url(" + imgLink + ")",
      "opacity": "1"
    }).children().attr('alt', imgLink);
  });

  // Menu sticky avec bouton de commande

  $(window).scroll(function() {
    let $height = $(window).scrollTop();
    if($height > 75) {
      $('#course_presentation_menu').addClass('menu_appear');
    } else {
      $('#course_presentation_menu').removeClass('menu_appear');
    }
  });

  $('.menu_anchor_link').click(function() {
    const yOffset = - $('#course_presentation_menu').height();
    const element = document.getElementById($(this).attr('data-anchor'));
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({top: y, behavior: 'smooth'});
  });

  // Modal message

  $('#contact_teacher').click(function() {
    $('.modal-backdrop.send_message').show();
    $('.modal.send_message').show();
  });

  $('#send_message, #contact_teacher_quit_modal').click(function() {
    $('.modal-backdrop.send_message').hide();
    $('.modal.send_message').hide();
  });

  $('div[data-show=true]').show();

  // Pop-up achat client

  if ($('#buy-pop-up').length > 0) {
    let start_animation = $('#buy-pop-up').data('n');
    setTimeout(popup_animation, start_animation * 1000);

    function popup_animation() {
      fadeInPopUp();
      setTimeout(fadeOutPopUp, 6000);
    }

    function fadeInPopUp() {
      $('#buy-pop-up').fadeIn(1000);
    }

    function fadeOutPopUp() {
      $('#buy-pop-up').fadeOut(1000);
    }
  }

  // Countdown

  const countdown_section = $('#countdown_section');
  const countdown_days = $('#countdown_days');
  const countdown_hours = $('#countdown_hours');
  const countdown_minutes = $('#countdown_minutes');
  const countdown_seconds = $('#countdown_seconds');

  let current_date = new Date();
  let current_day = current_date.getDay();
  let current_hour = current_date.getHours();

  const last_day = 0;
  const last_hour = 23;
  const last_minute = 59;
  const last_second = 59;

  function is_expired() {
    return current_day === 1 && current_hour < 8;
  }

  function nextDay(x){
    let now = current_date;
    now.setDate(now.getDate() + (x+(7-now.getDay())) % 7);
    return now;
  }

  function display_countdown(countDownDate) {
    countdown_section.show();

    // Update the count down every 1 second
    let x = setInterval(function() {

      // Get today's date and time
      let now = new Date().getTime();

      // Find the distance between now and the count down date
      let distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Output the result
      countdown_days.html(days);
      countdown_hours.html(hours);
      countdown_minutes.html(minutes);
      countdown_seconds.html(seconds);

      // If the count down is over, write some text
      if (distance < 0) {
        clearInterval(x);
        $('.countdown_container p').html('Offre expirée');
        countdown_days.html(0);
        countdown_hours.html(0);
        countdown_minutes.html(0);
        countdown_seconds.html(0);
      }
    }, 1000);
  }

  function launch_countdown() {
    if (!is_expired()) {
      let next_day = nextDay(last_day);
      let next_date = new Date(next_day.getFullYear(), next_day.getMonth(), next_day.getDate(), last_hour, last_minute, last_second);

      $('#countdown_date').html(
          I18n.t('dates.days.' + next_date.getDay())  + ' ' + next_date.getDate() + ' ' + I18n.t('dates.months.' + next_date.getMonth()) + ' ' + next_date.getFullYear() + ' à ' + next_date.getHours() + 'h' + next_date.getMinutes());

      display_countdown(next_date);
    }
  }

  if (countdown_section.length > 0) {
    launch_countdown();
  }
});


(function() {
  if (typeof Turbolinks === "undefined" || Turbolinks === null) {
    location.reload;
  }

  Turbolinks.dispatch("turbolinks:load");
}).call(this);